/** Matches backend `Vendors.vendorRole` */
export const VENDOR_ROLE_NAMES: Record<number, string> = {
  1: 'Hospital',
  2: 'Clinic',
  3: 'Medical Store',
  4: 'Ambulance Agency',
  5: 'Blood Bank',
  6: 'Diagnostic Center',
  8: 'Product Partner',
};

export const VENDOR_ROLE_FILTER_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: 'All vendor types' },
  ...([1, 2, 3, 4, 5, 6, 8] as const).map((role) => ({
    value: String(role),
    label: VENDOR_ROLE_NAMES[role],
  })),
];
